export const GET_MUNDIAL_STRUCTURE = 'GET_MUNDIAL_STRUCTURE';
export const GET_MUNDIAL_SCHEDULE_RESULTS = 'GET_MUNDIAL_SCHEDULE_RESULTS';
